module.exports = __webpack_public_path__ + "static/media/logo-menu.dadad5fa.png";